import { r as registerInstance, h, F as Fragment } from './index-5faac9d7.js';
import { i as isEmpty_1 } from './isEmpty-51908328.js';
import { a5 as SUBCATEGORY } from './currency-7be6806c.js';
import './product-card-c5e7a62c.js';
import { s as store } from './pes-router-store-0c1092be.js';
import './store-22db8dad.js';
import './index-e29b327a.js';
import { a as addHostToHmcUrls } from './utils-f0ef036b.js';
import './_nodeUtil-f95b2b52.js';
import './_commonjsHelpers-11ca3be1.js';
import './checkoutEventEmitter.service-41cc6ce1.js';
import './_basePickBy-e4f30088.js';
import './_arrayLikeKeys-728b0edd.js';
import './isSymbol-bae590b5.js';
import './_Stack-68736bd1.js';
import './toString-10b0f228.js';
import './_isIndex-3036d479.js';
import './keysIn-6ff99c07.js';
import './hasIn-53d8ae96.js';
import './_flatRest-cb1a737b.js';
import './_baseFlatten-65704796.js';
import './index-5d9a618b.js';
import './pes-product-link-74e48119.js';
import './utils-5735b62e.js';
import './analytics-205f1857.js';
import './helpers-c4d5ad02.js';
import './tslib.es6-613ce1cd.js';
import './__node-resolve_empty-7dfe5913.js';
import './helpers-e12aa36b.js';
import './toNumber-6e3a0b09.js';
import './index-e233ecdd.js';
import './cta-list-298471fe.js';
import './_baseFor-a28737de.js';
import './_copyObject-8b49fce6.js';
import './constants-7d3b1dc0.js';
import './number-57a50dcb.js';
import './analytics-b6a65ffa.js';
import './utils-5c7c3926.js';
import './utils-6c8f178b.js';
import './index-54dd34b7.js';
import './lodash-bd96d09c.js';

const pesAppSubcategoryCss = ".se-container-wide{max-width:1200px;margin-left:auto;margin-right:auto;padding-left:15px;padding-right:15px}@media screen and (min-width: 980px){.se-container-wide{padding-left:10px;padding-right:10px}}.hmc-banner-container{display:block;margin:0 auto;padding:0 16px 20px;box-sizing:border-box;max-width:1200px;overflow:visible;color:#626469;margin-top:42px;padding-bottom:0}.hmc-banner-container *,.hmc-banner-container *::before,.hmc-banner-container *::after{box-sizing:inherit}@media screen and (min-width: 980px){.hmc-banner-container{padding:0 10px}}@media screen and (min-width: 980px){.hmc-banner-container{margin-top:48px}}.subcategories__main{background-color:#fafafa}";

const PesAppSubcategory = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.host = undefined;
    this.subcategoryId = undefined;
    this.showBreadcrumbs = undefined;
    this.subcategoryData = null;
    this.recentlyViewedProducts = undefined;
    this.countryCode = undefined;
    this.languageCode = undefined;
    this.hostWithLocale = '';
  }
  componentWillRender() {
    store.set('enableAppRouting', true);
  }
  componentWillLoad() {
    this.hostWithLocale = `${this.host}${this.countryCode}/${this.languageCode}/`;
  }
  get customBreadcrumbs() {
    var _a, _b;
    if (!this.showBreadcrumbs) {
      return null;
    }
    return {
      breadcrumbs: this.subcategoryData
        && ((_b = (_a = this.subcategoryData.subcategoryBreadcrumbs) === null || _a === void 0 ? void 0 : _a.breadcrumbs) === null || _b === void 0 ? void 0 : _b.filter((breadcrumb) => {
          return !['SITE', 'BUSINESS'].includes(breadcrumb.itemType);
        })),
    };
  }
  get hmcBanner() {
    var _a;
    if (!((_a = this.subcategoryData) === null || _a === void 0 ? void 0 : _a.hmcBanner)) {
      return {};
    }
    const { hmcBanner } = this.subcategoryData;
    addHostToHmcUrls(this.host, hmcBanner);
    return hmcBanner;
  }
  render() {
    const { subcategoryBreadcrumbs: { hideOnMobile }, subcategoryDescription: { name, description, readLessLabel, readMoreLabel }, subcategoryRanges: { rangePartofLabel, rangeProductsViewDetailsLabel, productRelationsViewProdLabel, viewOnLabel, ranges, subCatagoryProductRangeLabel, avoidAccents, }, } = this.subcategoryData;
    const { sourceId, categoryName, parentCategoryId, hasQuestionnaire, categoryProductConfiguratorUrl, questionnaireUrl, rangeTooltipUrl, selectorConfigUrl, labels, host, token, channel, pageSource, } = this.hmcBanner;
    return (h(Fragment, null, h("div", { class: "subcategories__main" }, this.showBreadcrumbs && (h("pes-breadcrumbs", Object.assign({}, this.customBreadcrumbs, { hideOnMobile: hideOnMobile, class: "pes-app-pdp__section pes-app-pdp__section--breadcrumbs", hostWithLocale: this.hostWithLocale }))), h("header", null, h("pes-category-description", { name: name, description: description, readMoreLabel: readMoreLabel, readLessLabel: readLessLabel })), h("main", null, !isEmpty_1(this.hmcBanner) && (h("div", { class: "hmc-banner-container" }, h("pes-hmc-banner", { sourceId: sourceId, categoryName: categoryName, parentCategoryId: parentCategoryId, hasQuestionnaire: hasQuestionnaire, categoryProductConfiguratorUrl: categoryProductConfiguratorUrl, questionnaireUrl: questionnaireUrl, rangeTooltipUrl: rangeTooltipUrl, selectorConfigUrl: selectorConfigUrl, labels: labels, hmcHost: host, token: token, channel: channel, pageSource: pageSource }))), h("pes-category-range-list", { rangePartofLabel: rangePartofLabel, rangeProductsViewDetailsLabel: rangeProductsViewDetailsLabel, productRelationsViewProdLabel: productRelationsViewProdLabel, viewOnLabel: viewOnLabel, ranges: ranges, subCatagoryProductRangeLabel: subCatagoryProductRangeLabel, avoidAccents: avoidAccents, hostWithLocale: this.hostWithLocale, subcategoryId: this.subcategoryId }), h("pes-products-carousel", Object.assign({}, this.recentlyViewedProducts, { class: "pes-app-subcategory__section", hostWithLocale: this.hostWithLocale, pageId: this.subcategoryId, pageType: SUBCATEGORY }))))));
  }
};
PesAppSubcategory.style = pesAppSubcategoryCss;

export { PesAppSubcategory as pes_app_subcategory };
